import {
  Dialog,
  DialogBody,
  DialogTitle,
} from "@/components/ui/dialog/Dialog";
import LoadingPlaceholder from "@/components/ui/loading-placeholder/LoadingPlaceholder";
import { useMissionStepLog } from "@/services/api/agentic-v2/queries/useMissionStepLog";
import { MissionStepLogPanel } from "./MissionStepLogPanel";

export interface MissionStepLogDialogProps {
  missionId: string;
  open: boolean;
  onClose: () => void;
}

export function MissionStepLogDialog({
  missionId,
  open,
  onClose,
}: MissionStepLogDialogProps) {
  const query = useMissionStepLog({ missionId, enabled: open });
  const items = query.data?.items ?? [];

  return (
    <Dialog open={open} onClose={onClose} className="max-w-2xl">
      <DialogTitle>Step audit log</DialogTitle>
      <DialogBody>
        {query.isLoading ? (
          <LoadingPlaceholder height="12rem" width="100%" />
        ) : query.isError ? (
          <p className="text-sm text-rose-600 dark:text-rose-300">
            Failed to load step log: {query.error?.message ?? "unknown error"}
          </p>
        ) : (
          <MissionStepLogPanel items={items} />
        )}
      </DialogBody>
    </Dialog>
  );
}
